import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import instantsearch from 'instantsearch.js';
import { stats } from 'instantsearch.js/es/widgets';
import { searchBoxWithLabelWidget } from './search/widgets/searchBoxWithLabel';

const { url = null, apiKeySearch = null } = window.MeiliSearchConfig;
const indexName = 'search';

const { searchClient } = instantMeiliSearch(url, apiKeySearch, {
    placeholderSearch: false,
    primaryKey: 'id',
});

const search = instantsearch({
    indexName,
    searchClient,
    routing: false,
    future: {
        preserveSharedStateOnUnmount: false,
    },
});

const getSearchUrl = (query = null) => `/suche${query ? `?${indexName}[query]=${query}` : ''}`;

search.addWidgets([
    searchBoxWithLabelWidget({
        container: '[data-widget="searchbox"]',
        label: 'Schnellsuche',
        placeholder: 'Suchbegriff eingeben …',
        showSubmit: true,
        submitAriaLabel: 'Suchen',
    }),
    stats({
        container: '[data-widget="stats"]',
        templates: {
            text(data, { html }) {
                return html`<a
                    class="navigation-quick-search__stats-link"
                    href="${getSearchUrl(data.query)}"
                    tabindex="-1"
                >
                    <span class="navigation-quick-search__stats-badge">
                        ${Number(data.nbHits).toLocaleString()}
                    </span>
                    <span class="navigation-quick-search__stats-text">Einträge</span>
                </a>`;
            },
        },
    }),
]);

search.start();

// once the form is submitted, redirect to the full search page
const searchForm = document.querySelector('.navigation-quick-search .ais-SearchBoxWithLabel-form');
searchForm.addEventListener('submit', e => {
    const query = searchForm.querySelector('.ais-SearchBoxWithLabel-input').value;
    window.location = getSearchUrl(query);
});
